import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { TrapFocusModule } from '®shared/trap-focus';

import { ReviewService } from '../review.service';

import { RequestReviewModalComponent } from './request-review-modal.component';
import { RequestReviewEffects } from './request-review.effects';
import { requestReviewReducer } from './request-review.reducer';
import {
  STATE_FEATURE_REQUEST_REVIEW,
  getInitialRequestReviewState,
} from './request-review.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([RequestReviewEffects]),
    ModalModule,
    StoreModule.forFeature(STATE_FEATURE_REQUEST_REVIEW, requestReviewReducer, {
      initialState: getInitialRequestReviewState,
    }),
    TrapFocusModule,
  ],
  declarations: [RequestReviewModalComponent],
  exports: [RequestReviewModalComponent],
  providers: [ReviewService],
})
export class RequestReviewModule {}
